export const defaultColors = [
  '#87E78D', // Concluida
  '#CC9FFF', // EmAndamento
  '#FFE34C', // Pausadas
  '#4365A8', // Programadas
  '#FF7979', // Atrasadas
  '#444444', // Canceladas
];

export const emptyColor = ['#3980FF']; // Vazio
